const LINK = {
  BLOG: { name: 'Blog', url: '/page/blog' },
  SIGN_IN: { name: 'Sign In', url: '/sign-in' },
  SIGN_OUT: { name: 'Sign Out', url: '/sign-out' },
  ADDRESS_BOOK: { name: 'Address Book', url: '/account/address-book' },
  PURCHASE_HISTORY: { name: 'Purchase History', url: '/account/purchase-history' },
  EXCLUSIVE_PRIVILEGES: { name: 'Exclusive Privileges', url: '/account/exclusive-privileges' },
  ORDER_HISTORY: { name: 'Online Order Update', url: '/account/order-history' },
  MY_ACCOUNT: { name: 'My Account', url: '/account' },
  MY_PROFILE: { name: 'My Profile', url: '/account/profile' },
  REWARDS: { name: 'Apex Rewards', url: '/account/reward-points' },
  REWARDS_BLOGS_EVENTS: { name: 'Rewards Blogs & Events', url: '/account/rewards-blogs-events' },
  WISHLIST: { name: 'My Wishlist', url: '/account/wishlist' },
  MY_COUPONS: { name: 'My Coupons', url: '/account/my-coupons' },
  FEEDBACK_HISTORY: { name: 'Feedback History', url: '/account/feedback-history' },
  FIND_A_STORE: { name: 'Find A Store', url: '/store-locator' },
  HELP: { name: 'Help', url: '#help' },
  CART: { name: 'Shopping Bag', url: '/cart' },
  CONTACT_US: { name: 'Contact Us', url: '/contact-us' },
  CAMPAIGNS: { name: 'Campaigns', url: '/campaigns' },
  SUPPORT: { name: 'Support', url: '/page/contact-us' },
  CORPORATE: { name: 'Corporate', url: '/page/corporate' },
  Loyality: { name: 'Apex Loyality Program', url: '/account/loyality' },
};

export default LINK;
